module.exports = __webpack_public_path__ + "static/media/estrada.3a32f398.webp";